export default __webpack_public_path__ + "static/media/airstrapz-wht-banner-1.a93aff62.jpg";